<div class="float-right">
  <button class="btn btn-primary ac-btn-primary" (click)="open()">
    <i class="fas fa-shopping-cart"> </i> Cart <span class="badge badge-light mx-2 cart-count">{{ count }}</span>
  </button>
</div>
